<template>
  <div class="phome">
    <section class="hero" aria-labelledby="hero-title">
      <div class="hero-inner">
        <h1 id="hero-title">Logiciel de facturation électronique français</h1>
        <h2 class="subtitle">Gestion client, prospection commerciale et comptabilité tout-en-un</h2>
        <p class="description">
          Citron est un logiciel SaaS français conçu pour simplifier votre gestion d’entreprise&nbsp;:
          facturation électronique, suivi des clients, prospection commerciale et gestion comptable.
          Vos données sont sécurisées et hébergées en France, dans le respect du RGPD.
        </p>
        <div class="pub-btn-row">
          <router-link to="/register" class="pub-btn pub-btn--primary">Créer mon compte</router-link>
          <router-link to="/login" class="pub-btn pub-btn--ghost">Connexion</router-link>
        </div>

        <figure class="shot">
          <img src="/img/apercu-statistiques.webp" width="1600" height="593"
               alt="Tableau de bord Statistiques du Gestionnaire Citron : chiffre d'affaires facturé et encaissé, devis, clients actifs et factures en retard">
          <figcaption>Le tableau de bord Statistiques : facturé, encaissé, retards et signatures.</figcaption>
        </figure>

      </div>
    </section>

    <section class="features" aria-labelledby="features-title">
      <div class="features-inner">
        <h2 id="features-title">Un dossier suivi du premier contact à la comptabilité</h2>
        <p class="lead">Chaque information est saisie une fois : la fiche client alimente le devis, l'acompte se déduit de la facture finale, les achats se rattachent au dossier et tout alimente l'export comptable et les statistiques.</p>
        <ul class="feature-list">
          <li v-for="feature in features" :key="feature.path">
            <h3><a :href="siteUrl + feature.path">{{ feature.name }}</a></h3>
            <p>{{ feature.text }}</p>
          </li>
        </ul>
      </div>
    </section>

    <section class="band-cta" aria-labelledby="cta-title">
      <div class="band-inner">
        <h2 id="cta-title">Essayez le Gestionnaire Citron</h2>
        <p>Créez votre compte, ou consultez les offres avant de vous lancer.</p>
        <div class="pub-btn-row">
          <router-link to="/register" class="pub-btn pub-btn--ink">Créer mon compte</router-link>
          <router-link to="/tarification" class="pub-btn pub-btn--ghost">Voir les tarifs</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import {SITE_URL, FEATURES} from "@/components/public/siteLinks";

  /**
   * Accueil du gestionnaire pour une personne non connectée : présentation, aperçu de l'application,
   * fonctions (avec renvoi vers leur page sur le site) et appel à l'action.
   */
  export default {
    name: 'PublicHome',
    data() {
      return {
        siteUrl: SITE_URL,
        features: FEATURES,
      }
    }
  }
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/public.styl';

.phome
  flex 1 0 auto
  align-self stretch
  width 100%
  display flex
  flex-direction column

// ---------------------------------------------------------- présentation
.hero
  background-color PUB_PAPER
  padding-top clamp(32px, 6vw, 72px)
  padding-bottom clamp(40px, 7vw, 88px)

.hero-inner
  pub-container()
  h1
    margin 0
    max-width 20ch
    color PUB_INK
    font-family PUB_FONT_DISPLAY
    font-weight 400
    font-size clamp(2.1rem, 5.6vw, 3.5rem) !important
    line-height 1.12
    letter-spacing -0.015em
    text-align left
    text-transform none

.subtitle
  margin 18px 0 0
  max-width 34ch
  color PUB_INK_SOFT
  font-family PUB_FONT_TEXT
  font-weight 400
  font-size clamp(1.15rem, 2.4vw, 1.5rem) !important
  line-height 1.4

.description
  margin 18px 0 0
  max-width 62ch
  color PUB_INK
  font-family PUB_FONT_TEXT
  line-height 1.65

.hero .pub-btn-row
  margin-top 28px


.shot
  position relative
  margin 48px 0 0
  img
    position relative
    display block
    width 100%
    height auto
    box-sizing border-box
    border 2px solid PUB_INK
    border-radius 4px
    background PUB_WHITE
    // Une seconde feuille dépasse derrière la capture
    box-shadow 8px 8px 0 0 PUB_PAPER, 8px 8px 0 2px PUB_INK
  figcaption
    margin-top 26px
    color PUB_MUTED
    font-family PUB_FONT_TEXT
    font-size 0.95rem

// ---------------------------------------------------------- fonctions
.features
  background-color PUB_PAPER
  border-top 1px solid PUB_RULE
  border-bottom 1px solid PUB_RULE
  padding-top clamp(40px, 7vw, 88px)
  padding-bottom clamp(40px, 7vw, 88px)

.features-inner
  pub-container()
  h2
    margin 0
    max-width 24ch
    color PUB_INK
    font-family PUB_FONT_DISPLAY
    font-weight 400
    font-size clamp(1.6rem, 3.4vw, 2.3rem)
    line-height 1.18
  .lead
    margin 14px 0 0
    max-width 62ch
    color PUB_INK_SOFT
    font-family PUB_FONT_TEXT
    font-size 1.1rem
    line-height 1.55

.feature-list
  list-style none
  margin 36px 0 0
  padding 0
  border-top 2px solid PUB_INK
  li
    margin 0
    padding 20px 0
    border-bottom 1px solid PUB_RULE
  h3
    margin 0 0 6px
    color PUB_INK
    font-family PUB_FONT_DISPLAY
    font-weight 400
    font-size 1.35rem
    line-height 1.2
    a
      color PUB_INK
      font-family PUB_FONT_DISPLAY
      font-weight 400
      text-decoration none
      &:hover
        text-decoration underline
        text-decoration-color PUB_LEMON_DEEP
        text-decoration-thickness 2px
  p
    margin 0
    max-width 52ch
    color PUB_INK_SOFT
    font-family PUB_FONT_TEXT
    font-size 1rem
    line-height 1.55

// ---------------------------------------------------------- appel à l'action : la bande citron du site
.band-cta
  background-color PUB_LEMON
  border-top 2px solid PUB_INK
  padding-top clamp(36px, 6vw, 64px)
  padding-bottom clamp(36px, 6vw, 64px)

.band-inner
  pub-container()
  h2
    margin 0
    color PUB_INK
    font-family PUB_FONT_DISPLAY
    font-weight 400
    font-size clamp(1.6rem, 3.4vw, 2.3rem)
    line-height 1.18
  p
    margin 12px 0 0
    max-width 52ch
    color PUB_INK
    font-family PUB_FONT_TEXT
    font-size 1.1rem
  .pub-btn-row
    margin-top 24px

@media (min-width: 1000px)
  .feature-list
    display grid
    grid-template-columns 1fr 1fr
    column-gap 56px
</style>
